import Head from "next/head";
import { ReactNode } from "react";
import { FormatedText } from "./formated_text";

const SinglePage = ({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) => {
  return (
    <>
      <Head>
        <title>{`${title} | Find Free Online Courses | classhubs`}</title>
      </Head>
      <div className="w-full pt-32 pb-24 bg-[#f5f6fd]">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-center text-4xl font-extrabold">{title}</h1>
        </div>
      </div>
      <FormatedText className="max-w-7xl mx-auto px-12 py-10 md:px-24">
        {children}
      </FormatedText>
    </>
  );
};

export { SinglePage };
